import React, { useContext, useEffect } from "react";
import "./Buy_sell_Btns.css";
import { Context } from "../../../../../utils/context";

const Buy_sell_Btns = ({
  latestAmount,
  sellOnClick,
  BuyOnClick,
  setPrice,
  price,
}) => {
  const { buyOrSale, setBuyOrSale } = useContext(Context);

  const handleSellClick = () => {
    setBuyOrSale("sell");
    setPrice(latestAmount);
    sellOnClick?.();
  };

  const handleBuyClick = () => {
    setBuyOrSale("buy");
    setPrice(latestAmount);
    BuyOnClick?.();
  };

  useEffect(() => {
    setPrice(latestAmount);
  }, [latestAmount, setPrice]);

  return (
    <div className="buy-sell-container px-6 mt-2">
      {/* Current Price Display */}
      <div className="text-center mb-8">
        <p className="text-gray-400 text-sm uppercase max-md:-mb-2 tracking-wider">Current Price</p>
        <p className="text-4xl font-extrabold text-white mt-2 max-md:text-3xl ">${Number(latestAmount || 0).toFixed(2)}</p>
      </div>

      {/* Buy & Sell Buttons */}
      <div className="grid grid-cols-2 gap-6 max-md:scale-75 max-md:-mt-5"> 
        {/* BUY BUTTON */}
        <button
          onClick={handleBuyClick}
          className={`relative overflow-hidden rounded-2xl p-8 font-bold text-2xl transition-all duration-500 transform
            ${buyOrSale === "buy"
              ? "bg-green-600 text-white shadow-2xl shadow-green-500/50 scale-105 ring-4 ring-green-400/50"
              : "bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white hover:scale-105 hover:shadow-xl"}
          `}
        >
          <span className="relative z-10">BUY</span>
          {buyOrSale === "buy" && (
            <div className="absolute inset-0 bg-gradient-to-t from-green-500/30 to-transparent animate-pulse" />
          )}
        </button>

        {/* SELL BUTTON */}
        <button
          onClick={handleSellClick}
          className={`relative overflow-hidden rounded-2xl p-8 font-bold text-2xl transition-all duration-500 transform
            ${buyOrSale === "sell"
              ? "bg-red-600 text-white shadow-2xl shadow-red-500/50 scale-105 ring-4 ring-red-400/50"
              : "bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white hover:scale-105 hover:shadow-xl"}
          `}
        >
          <span className="relative z-10">SELL</span>
          {buyOrSale === "sell" && (
            <div className="absolute inset-0 bg-gradient-to-t from-red-500/30 to-transparent animate-pulse" />
          )}
        </button>
      </div>
    </div>
  );
};

export default Buy_sell_Btns;